import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { OrganizationUserService, OrganizationUserVM } from "@propertelligent/client-api";
import RightSideModal from "../../../newComponents/Modal/right-side-modal";
import InputField from "../../../newComponents/form-fields/InputField";
import apiHelper from "../../../utils/apiHelper";
import PhoneInput from "../../../newComponents/form-fields/PhoneInput";

interface EditProfileProps {
  isOpen?: boolean;
  onClose?: () => void;
  userId?: number; 
  refresh?: () => void;
}

const EditProfileModal = ({ isOpen, onClose, userId, refresh }: EditProfileProps) => {
  const [loading, setLoading] = useState(false);
  
  const methods = useForm<OrganizationUserVM>();
  const { reset, formState: { isDirty } } = methods;

  const fetchUserDetails = async () => {
    setLoading(true);
    const res = await apiHelper(
      OrganizationUserService.getApiOrganizationUser, 
      { showNotification: false }, 
      userId
    );
    
    if (res?.data?.success) {
      reset(res.data.success);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isOpen && userId) {
      fetchUserDetails();
    }
  }, [isOpen, userId]);

  const onSubmit = async (formData: any) => {
    
    const cleanPayload = {
      id: formData.id,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      title: formData.title || "",
      organizationUserTypeId: formData.organizationUserTypeId,
      organizationId: formData.organizationId,
      organizationUserId: userId,
    };

    // 2. API Call
    const res = await apiHelper(
      OrganizationUserService.putApiOrganizationUser,
      { title: "Profile Updated", showNotification: true, successMessage: "Profile has been updated successfully." },
      String(userId),
      cleanPayload 
    );

    if (res?.data) {
      refresh();
      onClose();
    }
  };

  return (
    <RightSideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Basic Details"
      buttonlabel={loading ? "Loading..." : "Save"}
      formId="edit-profile-form"
      isDirty={isDirty}
    >
      <FormProvider {...methods}>
        <form id="edit-profile-form" onSubmit={methods.handleSubmit(onSubmit)} className="p-3">
          <div className="row g-3">
            <div className="col-md-12">
              <InputField name="title" label="Title" placeholder="Enter title" />
            </div>
            <div className="col-md-6">
              <InputField name="firstName" label="First Name" required requiredMessage="First name is required" validation={{minLength: { value: 2, message: "First name must be at least 2 characters long" }, maxLength: { value: 20, message: "First name cannot exceed 20 characters" } }} onlyAlphabets />
            </div>
            <div className="col-md-6">
              <InputField name="lastName" label="Last Name" required requiredMessage="Last name is required" validation={{minLength: { value: 2, message: "Last name must be at least 2 characters long" }, maxLength: { value: 20, message: "Last name cannot exceed 20 characters" } }} onlyAlphabets />
            </div>
            <div className="col-md-12">
              <InputField name="email" label="Email Address" disabled />
            </div>
            <div className="col-md-12">
              <PhoneInput
                name="phoneNumber"
                label="Contact No"
                required
                placeholder="Enter contact number"
                className="phone-input-custom"
                requiredMessage="Contact number is required"
                defaultCountry="US"
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </RightSideModal>
  );
};

export default EditProfileModal;